import { useLayoutEffect, useMemo } from 'react';
import { useInputForm } from 'components/dataCreationForms/withInputForm';
import { ReportType } from 'shared/domain/report/types/model/common';
import {
  ReportMessageAttachmentsAvailabilityMap,
  ReportSectionAvailabilityMap,
} from '../model';
import {
  buildAvailabilityDependencyKey,
  buildValuesDependencyKey,
  getReportSectionSyncDescriptors,
  syncUnavailableReportSections,
} from './reportSectionSync';

export function useSyncUnavailableReportSections(
  availability: ReportSectionAvailabilityMap,
  messageAttachmentsAvailability: ReportMessageAttachmentsAvailabilityMap,
  reportType: ReportType
): void {
  const { values, setValues } = useInputForm();
  const descriptors = useMemo(
    () => getReportSectionSyncDescriptors(reportType),
    [reportType]
  );
  const availabilityKey = useMemo(
    () =>
      buildAvailabilityDependencyKey(
        availability,
        messageAttachmentsAvailability,
        descriptors
      ),
    [availability, messageAttachmentsAvailability, descriptors]
  );
  const valuesKey = useMemo(
    () =>
      buildValuesDependencyKey(
        values as Record<string, unknown>,
        descriptors
      ),
    [descriptors, values]
  );

  useLayoutEffect(() => {
    syncUnavailableReportSections({
      availability,
      messageAttachmentsAvailability,
      descriptors,
      values: values as Record<string, unknown>,
      setValues,
    });
  }, [descriptors, setValues, availabilityKey, valuesKey]);
}
